import { createBrowserHistory, createMemoryHistory } from 'history';
import withQuery from 'history-query-enhancer';
import { encode, decode } from 'qss';

// NOTE: This string will be replaced on build time with the package version.
var version = "22.28.0";

const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function parse(search) {
  // Note: the "?" needs to be removed.
  return decode(search.substring(1));
}
const createEnhancedHistory = withQuery({
  parse,
  stringify: encode
});
const browserHistory = createEnhancedHistory(
// For SSR compatibility
canUseDOM ? createBrowserHistory() : createMemoryHistory());

export { createEnhancedHistory, browserHistory as default, version };
